<template>
  <div>
    {{ translate.result.direct.received }}
    <br />
    {{ translate.result.direct.instruction }}
    <br />
    {{ translate.result.direct.whatsapp }}
    <br />
    <br />
    {{ translate.result.direct.thanks }}
  </div>
</template>

<script>
export default {
  name: 'direct-result',
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
};
</script>
